// This file can be replaced during build by using the `fileReplacements` array.
// When building for production, this file is replaced with `environment.prod.ts`.

import { getEnvVar } from '../utils';

export type Env = 'production' | 'preproduction' | 'staging' | 'dev';

export const environment = {
  amplitudeApiKey: getEnvVar<string>('VITE_AMPLITUDE_API_KEY') || '',
  beamerId: getEnvVar<string>('VITE_BEAMER_ID') || '',
  contentMediaUrl: getEnvVar<string>('VITE_CONTENT_MEDIA_URL') || '',
  datadogApplicationId: getEnvVar<string>('VITE_DD_SPO_APP_ID') || '',
  datadogClientToken: getEnvVar<string>('VITE_DD_SPO_CLIENT_TOKEN') || '',
  datadogEnv: getEnvVar<string>('VITE_DD_ENV') || 'development',
  datadogServiceName: getEnvVar<string>('VITE_DD_SPO_SERVICE_NAME') || '',
  datadogVersion: getEnvVar<string>('VITE_DD_SPO_VERSION') || '',
  env: getEnvVar<string>('VITE_NODE_ENV') || '',
  gtmId: getEnvVar<string>('VITE_GTM_ID') || '',
  legacyUrl: getEnvVar<string>('VITE_LEGACY_URL') || '',
  maintenanceUri: getEnvVar<string>('VITE_MAINTENANCE_URI') || '',
  // thoses following variables aren't trully env variables but variables created based on other variables values
  dev: getEnvVar<string>('VITE_NODE_ENV') === 'dev',
  preproduction: getEnvVar<string>('VITE_NODE_ENV') === 'preproduction',
  production: getEnvVar<string>('VITE_NODE_ENV') === 'production',
  staging: getEnvVar<string>('VITE_NODE_ENV') === 'staging',
  test: getEnvVar<string>('VITE_NODE_ENV') === 'test',
};
